var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.pageHasHeader)?_c('Header'):_vm._e(),(_vm.pageHasNavbar)?_c('Navbar'):_vm._e(),_c('router-view'),_c('Footer'),_c('notifications',{attrs:{"position":"bottom right","group":"main"}}),_c('div',[_c('b-overlay',{attrs:{"show":_vm.loadingFull,"no-wrap":"","bg-color":"rgba(0,0,0,.4)"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }